<template>
  <v-dialog
    hide-overlay
    :overlay-opacity="0"
    :transition="false"
    persistent
    ref="dialog"
    width="561px"
    :value="isOpen ? true : false"
    absolute
  >
    <div class="card-overlay" @click="onOverlayClick"/>

    <v-card style="width: 561px" v-if="isOpen">
      <template
        v-if="selectedTheme !== undefined && Object.keys(selectedTheme).length && selectedTheme.screenshot_url"
      >
        <v-img
          height="285px"
          width="100%"
          position="top center"
          :src="selectedTheme.screenshot_url"
        />
        <v-divider />
      </template>
      <v-card-text class="px-10 pt-8">
        <v-btn x-small icon :disabled="loading" @click="closeModal" class="close-model">
          <v-icon>$close</v-icon>
        </v-btn>
        <h6>{{ $t("heading.onboarding.chooseProduct.website.title") }}</h6>
        <p class="p-3 mt-2">
          {{ $t("heading.onboarding.chooseProduct.website.subtitle") }}
        </p>
        <v-form ref="form" @submit.prevent="submitSiteName">
          <v-text-field
            outlined
            :placeholder="$t('form.placeholder.website')"
            v-model="siteName"
            hide-details=""
            :rules="siteNameRules"
            class="v-input--lg"
            validate-on-blur
            @keydown.enter.prevent="submitSiteName"
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="d-flex flex-column pb-4 px-10 pt-2">
        <v-btn
          x-large
          elevation="0"
          :loading="loading"
          @click="$emit('site-name-selected', siteName)"
          color="primary"
          block
        >
          {{ $t("button.website.create") }}
          <v-icon size="24" class="ml-2">$arrowright</v-icon>
        </v-btn>
        <v-btn
          v-if="services.length > 1"
          :disabled="loading"
          @click="onChangeServiceClick"
          x-large
          elevation="0"
          class="mx-0 mt-2"
          color="gray"
          text
          block
        >
            <span class="p-1 font-weight-light gray--text text--darken-1">
              {{ $t("button.service.change") }}
            </span>
        </v-btn>
        <v-btn
          v-else-if="!selectedService.plan_default_theme"
          :disabled="loading"
          @click="onChangeThemeClick"
          x-large
          elevation="0"
          class="mx-0 mt-2"
          color="gray"
          text
          block
        >
            <span class="p-2 font-weight-light gray--text text--darken-1">
              {{ $t("button.theme.change") }}
            </span>
        </v-btn>
        <v-btn
          v-else
          :disabled="loading"
          @click="closeModal"
          x-large
          elevation="0"
          class="mx-0 mt-2"
          color="gray"
          text
          block
        >
            <span class="p-2 font-weight-light gray--text text--darken-1">
              {{ $t("button.maybeLater") }}
            </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FormRulesMixin from "../../mixins/FormRulesMixin";

export default {
  name: "OnboardingChooseSiteNameModal",
  mixins: [FormRulesMixin],

  data: function () {
    return {
      siteName: "",
    };
  },
  props: {
    isOpen: [Boolean, String],
    loading: Boolean,
    services: Array,
    selectedService: Object,
    selectedTheme: Object,
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  methods: {
    closeModal() {
      if (!this.loading) {
        this.$emit('remove-modal');
      }
    },
    onOverlayClick() {
      if (!this.loading && this.$refs.dialog) {
        this.$refs.dialog.animateClick();
      }
    },
    onChangeServiceClick() {
      if (!this.loading) {
        this.$emit('change-service-button-clicked');
      }
    },
    onChangeThemeClick() {
      if (!this.loading) {
        this.$emit('change-theme-button-clicked');
      }
    },
    handleBeforeUnload(e) {
      if (!this.loading) {
        return;
      }
      const message = 'Installation is in progress. Leaving the page may cause the process to fail.';
      (e || window.event).returnValue = message;
      return message;
    },
    submitSiteName() {
      if (!this.loading) {
        this.$emit('site-name-selected', this.siteName);
      }
    },
  },
  watch: {
    isOpen: function (value) {
      value
        ? this.$store.dispatch("lockBodyScroll")
        : this.$store.dispatch("unlockBodyScroll");
    },
  },

};
</script>

<style lang="scss" scoped>
.v-card::v-deep {
  .v-card__text {
    -webkit-line-clamp: unset !important;
  }

  @media (max-width: 480px) {
    .v-card__text,
    .v-card__actions {
      padding-left: 24px !important;
      padding-right: 24px !important;
    }
  }
}

.custom-dropdown-select--onboarding {
  display: none !important;
}

.v-input::v-deep {
  &.v-select.v-input--lg {
    .v-input__control .v-input__slot {
      min-height: 56px;
      max-height: fit-content;
      border-radius: 8px;

      input {
        display: none;
      }
    }
  }
}

.v-input::v-deep {
  &.v-input--lg {
    .v-input__control .v-input__slot {
      border-radius: 8px;
    }
  }
}

.v-dialog__content::v-deep {
  .v-dialog {
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>

<style lang="scss">
.close-model {
  position: absolute;
  top: -40px;
  right: -8px;
}

.custom-dropdown-select--onboarding::v-deep {
  overflow-y: auto !important;
  padding-left: 16px;

  .v-list-item {
    color: unset !important;
    caret-color: unset !important;
  }
}
</style>